module.exports = __webpack_public_path__ + "img/mission.8736a72c.png";